import cookie from 'js-cookie'

import {euCountriesCodes} from '@/utils/constants'
import {otherCookiesAllowedCookieName, visitorCookieValidityInDays} from '@/utils/constants/http'

// EEA + UK + CH: everywhere prior opt-in is expected before non-essential cookies.
// Deliberately a country list, not a `Region` one - `Region` is a market preference the
// visitor can change, and it cannot represent IS or LI at all.
const priorConsentCountryCodes = [...euCountriesCodes, 'IS', 'NO', 'LI', 'GB', 'CH']

export const requiresPriorConsent = (country?: string) =>
  !country || priorConsentCountryCodes.includes(country.toUpperCase())

export const handleConsent = (value: boolean) => {
  // Asked again after six months rather than kept indefinitely
  cookie.set(otherCookiesAllowedCookieName, value.toString(), {
    expires: visitorCookieValidityInDays,
    sameSite: 'lax',
  })
  // @ts-expect-error
  window.onConsentChange?.({adConsentGranted: value})
}
